(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vantek-category-menu"] && !Shopify.designMode) return;
  try {
    class VantekCategoryMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      this.tabs = Array.from(this.querySelectorAll('[data-category-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-category-panel]'));
      const list = this.querySelector('.vantek-category-menu__departments');
      if (!list || !this.tabs.length || this.tabs.length !== this.panels.length) return;
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-orientation', 'vertical');
      this.tabs.forEach((tab, index) => {
        tab.parentElement.setAttribute('role', 'presentation');
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.panelId);
        tab.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.select(index);
        });
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key !== ' ') return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        });
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].tabIndex = 0;
      });
      const current = this.tabs.findIndex((tab) => tab.hasAttribute('data-current-department'));
      this.select(Math.max(0, current));
      this.dataset.enhanced = 'true';
    }

    select(index) {
      this.tabs.forEach((tab, position) => {
        const selected = position === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[position].hidden = !selected;
      });
      this.querySelector('.vantek-category-menu__panels').scrollTop = 0;
    }
  }

  if (!customElements.get('vantek-category-menu')) {
    customElements.define('vantek-category-menu', VantekCategoryMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
